<page-banner imageUrl="page-banner-2.png" headingText="Our staff"></page-banner>

<div class="content-container">
  <div class="container">

    <div class="row">
      <div class="col-12">
        <h2>Staff</h2>
        <p>All of our staff are experienced wine industry professionals with a strong commitment to customer service. We pride ourselves on our honesty and integrity.</p>
      </div>
    </div>


    <div class="row">

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Nick Stamford</h3>
            <span class="">Managing Director</span>
          </div>
        </div>
      </div>


      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Simon Evans</h3>
            <span class="">General Manager</span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Anthony Caputi</h3>
            <span class="">Auction Manager</span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Mick Dowling</h3>
            <span class="">National Sales Manager</span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Peter Maher</h3>
            <span class="">Wine Consultant</span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">Hugh French</h3>
            <span class="">Wine Consultant</span>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-3">
        <div class="card">
          <img class="card-img-top" src="/assets/images/staff-1.png" alt="">
          <div class="card-body">
            <h3 class="">David Shoobert</h3>
            <span class="">Wine Consultant</span>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-12">
        <p>Please feel free to contact any member of our team for further information or assistance.</p>
      </div>
    </div>

  </div>
</div>
